import Icon from "@mui/icons-material/AlternateEmail";

export default function ReferencesIcon(props) {
	return <Icon color={props.color} fontSize={props.fontSize || "medium"} />;
}
